import type {
  AddressFormValidationErrors,
  FieldName,
} from '@jouzen/ecom-components/v3/AddressForm';

const getMetricsErrors = (
  errors: AddressFormValidationErrors,
): Partial<Record<FieldName, string>> => {
  return Object.entries(errors).reduce((obj, [key, val]) => {
    const msgKey = val.props?.id;

    return {
      ...obj,
      [key]: msgKey ?? val, // fallback in case val was already a string
    };
  }, {});
};

export default getMetricsErrors;
